<template>
  <ValidationObserver v-slot="{ handleSubmit }">
    <form @submit.prevent="handleSubmit(handleFormSubmit)">
      <div class="row">
        <div class="col-md-12">
          <div class="form-row d-flex justify-content-end">
            <div class="form-group p-2 m-0">
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  value=""
                  id="is_bundle"
                  v-model="internalProduct.is_bundle"
                />
                <label class="form-check-label" for="internalProduct.is_bundle">
                  Bundle
                </label>
              </div>
            </div>
            <div class="form-group p-2 m-0">
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  value=""
                  id="is_combo"
                  v-model="internalProduct.is_combo"
                />
                <label class="form-check-label" for="internalProduct.is_combo">
                  Combo
                </label>
              </div>
            </div>
            <div class="form-group p-2 m-0">
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  value=""
                  id="id_recommend_product"
                  v-model="internalProduct.recommend_product"
                />
                <label
                  class="form-check-label"
                  for="internalProduct.recommend_product"
                >
                  Recommend
                </label>
              </div>
            </div>
            <div class="form-group p-2 m-0">
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  value=""
                  id="show_code"
                  v-model="internalProduct.show_code"
                />
                <label class="form-check-label" for="internalProduct.show_code">
                  Show {code}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <fieldset class="form-group p-3 border">
            <legend class="w-auto px-2">
              <i class="fa fa-info-circle" aria-hidden="true"></i> General
              Information
            </legend>

            <div class="form-row">
              <div class="form-group col-md-4">
                <label for="id_sku"
                  >SKU<code v-if="internalProduct.show_code">{sku}</code></label
                >
                <ValidationProvider
                  name="sku"
                  rules="required|skuunique"
                  :debounce="500"
                  v-slot="{ errors }"
                >
                  <input
                    type="text"
                    class="form-control"
                    id="id_sku"
                    placeholder="SKU"
                    v-model="internalProduct.sku"
                  />
                  <div class="text-danger">
                    <small id="error">{{ errors[0] }}</small>
                  </div>
                </ValidationProvider>
              </div>
              <div class="form-group col-md-5">&nbsp;</div>
              <div class="form-group col-md-1">
                <label for="id_condition">Condition</label>
                <select
                  class="form-control"
                  id="id_condition"
                  v-model="internalProduct.condition"
                >
                  <option value="UNKNOWN">Unknown</option>
                  <option value="NEW">New</option>
                  <option value="USED">Used</option>
                </select>
              </div>
              <div class="form-group col-md-1">
                <label for="sorting_order">Sorting</label>
                <select
                  class="form-control"
                  v-model="internalProduct.sorting_order"
                >
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
                </select>
              </div>
              <div class="form-group col-md-1">
                <label for="internalProduct.is_featured">Featured</label>
                <select
                  class="form-control"
                  id="is_featured"
                  v-model="internalProduct.is_featured"
                >
                  <option value="0">No</option>
                  <option value="1">Yes</option>
                </select>
              </div>
            </div>

            <div class="form-row">
              <div class="form-group col-md-12">
                <label for="id_title"
                  >Title<code v-if="internalProduct.show_code"
                    >{title}</code
                  ></label
                >
                <input
                  type="text"
                  class="form-control"
                  id="id_title"
                  placeholder="Title"
                  v-model="internalProduct.title"
                />
              </div>
            </div>

            <div class="form-row">
              <!--
                <div class="form-group col-md-3">
                  <label for="id_brand">Brand<code v-if="internalProduct.show_code">{brand}</code></label>
                  <input
                    type="text"
                    class="form-control"
                    id="id_brand"
                    placeholder="Brand"
                    v-model="internalProduct.brand"
                  />
                </div>
-->
              <div class="form-group col-md-3">
                <label for="id_brand">Brand</label>
                <select
                  class="form-control"
                  v-model="internalProduct.internal_product_brand_id"
                >
                  <option value>-- None --</option>
                  <option
                    v-for="brand in brands"
                    :key="brand.id"
                    :value="brand.id"
                  >
                    {{ brand.name }}
                  </option>
                </select>
              </div>

              <div class="form-group col-md-3">
                <label for="id_category"
                  >Category<code v-if="internalProduct.show_code"
                    >{category}</code
                  ></label
                >
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <select
                    :class="errors.length === 0 ? '' : 'error'"
                    class="form-control"
                    v-model="internalProduct.internal_product_category_id"
                    @change="chooseCategory"
                  >
                    <option value>-- None --</option>
                    <option
                      v-for="category in categories"
                      :key="category.id"
                      :value="category.id"
                    >
                      {{ category.name }}
                    </option>
                  </select>
                  <div class="text-danger">
                    <small>{{ errors[0] }}</small>
                  </div>
                </ValidationProvider>
              </div>

              <div class="form-group col-md-3">
                <label for="id_types"
                  >Type<code v-if="internalProduct.show_code"
                    >{type}</code
                  ></label
                >
                <template v-if="types.length === 0">
                  <span
                    tabindex="0"
                    data-toggle="tooltip"
                    title="Choose a category and series first"
                  >
                    <select class="form-control" disabled>
                      <option value>-- None --</option>
                    </select>
                  </span>
                </template>
                <template v-else>
                  <select
                    class="form-control"
                    v-model="internalProduct.internal_product_type_id"
                    @change="chooseType"
                  >
                    <option value>-- None --</option>
                    <option
                      v-for="type in types"
                      :key="type.id"
                      :value="type.id"
                    >
                      {{ type.name }}
                    </option>
                  </select>
                </template>
              </div>

              <div class="form-group col-md-3">
                <label for="id_series"
                  >Series<code v-if="internalProduct.show_code"
                    >{series}</code
                  ></label
                >
                <template v-if="series.length === 0">
                  <span
                    tabindex="0"
                    data-toggle="tooltip"
                    title="Choose a category first"
                  >
                    <select class="form-control" disabled>
                      <option value>-- None --</option>
                    </select>
                  </span>
                </template>
                <template v-else>
                  <select
                    class="form-control"
                    v-model="internalProduct.internal_product_series_id"
                  >
                    <option value>-- None --</option>
                    <option
                      v-for="serie in series"
                      :key="serie.id"
                      :value="serie.id"
                    >
                      {{ serie.sku }}
                    </option>
                  </select>
                </template>
              </div>

              <div class="form-group col-md-3">
                <label for="id_purpose">Purposes</label>
                <vue-multiselect
                  id="id_purpose"
                  v-model="internalProduct.purposes_selected"
                  tag-placeholder="Choose..."
                  placeholder="Choose..."
                  label="text"
                  track-by="text"
                  :options="purposes"
                  :multiple="true"
                  :taggable="true"
                />
              </div>
            </div>

            <div class="form-row">
              <div class="form-group col-md-12"><hr /></div>
            </div>

            <div class="form-row">
              <div class="form-group col-md-6">
                <label for="id_short_description">Short Description</label>
                <textarea
                  class="form-control"
                  id="id_short_description"
                  placeholder="Short Description"
                  v-model="internalProduct.short_description"
                ></textarea>
              </div>
              <div class="form-group col-md-6">
                <label for="id_description">Description</label>
                <textarea
                  class="form-control"
                  id="id_description"
                  placeholder="Description"
                  v-model="internalProduct.description"
                ></textarea>
              </div>
            </div>
          </fieldset>

          <fieldset class="form-group p-3 border">
            <legend class="w-auto px-2">
              <i class="fa fa-tag" aria-hidden="true"></i> Price
            </legend>
            <div class="form-row">
              <div class="form-group col-md-2">
                <label for="id_retail_price">Retail</label>
                <ValidationProvider rules="money" v-slot="{ errors }">
                  <div class="input-group mb-2 mr-sm-2">
                    <div class="input-group-prepend">
                      <div class="input-group-text">$</div>
                    </div>
                    <input
                      type="text"
                      class="form-control"
                      id="id_retail_price"
                      placeholder="Retail Price"
                      v-model="internalProduct.retail_price"
                    />
                  </div>
                  <span class="text-danger"
                    ><small>{{ errors[0] }}</small></span
                  >
                </ValidationProvider>
              </div>
              <div class="form-group col-md-2">
                <label for="id_retail_price">Wholesale</label>
                <ValidationProvider rules="money" v-slot="{ errors }">
                  <div class="input-group mb-2 mr-sm-2">
                    <div class="input-group-prepend">
                      <div class="input-group-text">$</div>
                    </div>
                    <input
                      type="text"
                      class="form-control"
                      id="id_wholesale_price"
                      v-model="internalProduct.wholesale_price"
                    />
                  </div>
                  <span class="text-danger"
                    ><small>{{ errors[0] }}</small></span
                  >
                </ValidationProvider>
              </div>
              <div class="form-group col-md-2">&nbsp;</div>
              <div class="form-group col-md-2">
                <label for="id_retail_price">Cost</label>
                <ValidationProvider rules="money" v-slot="{ errors }">
                  <div class="input-group mb-2 mr-sm-2">
                    <div class="input-group-prepend">
                      <div class="input-group-text">$</div>
                    </div>
                    <input
                      type="text"
                      class="form-control"
                      id="id_cost"
                      v-model="internalProduct.cost"
                    />
                  </div>
                  <span class="text-danger"
                    ><small>{{ errors[0] }}</small></span
                  >
                </ValidationProvider>
              </div>
              <div class="form-group col-md-2">
                <label for="id_retail_price">Min</label>
                <ValidationProvider rules="money" v-slot="{ errors }">
                  <div class="input-group mb-2 mr-sm-2">
                    <div class="input-group-prepend">
                      <div class="input-group-text">$</div>
                    </div>
                    <input
                      type="text"
                      class="form-control"
                      id="id_min_price"
                      v-model="internalProduct.min_price"
                    />
                  </div>
                  <span class="text-danger"
                    ><small>{{ errors[0] }}</small></span
                  >
                </ValidationProvider>
              </div>
              <div class="form-group col-md-2">
                <label for="id_retail_price">Max</label>
                <ValidationProvider rules="money" v-slot="{ errors }">
                  <div class="input-group mb-2 mr-sm-2">
                    <div class="input-group-prepend">
                      <div class="input-group-text">$</div>
                    </div>
                    <input
                      type="text"
                      class="form-control"
                      id="id_max_price"
                      v-model="internalProduct.max_price"
                    />
                  </div>
                  <span class="text-danger"
                    ><small>{{ errors[0] }}</small></span
                  >
                </ValidationProvider>
              </div>
            </div>
          </fieldset>

          <fieldset class="form-group p-3 border">
            <legend class="w-auto px-2">
              <i class="fa fa-hashtag" aria-hidden="true"></i> Identifiers
            </legend>
            <div class="form-row">
              <div class="form-group col-md-3">
                <label for="id_asin">ASIN</label>
                <input
                  type="text"
                  class="form-control"
                  id="id_asin"
                  placeholder="ASIN"
                  v-model="internalProduct.asin"
                />
              </div>
              <div class="form-group col-md-3">
                <label for="id_upc">UPC</label>
                <input
                  type="text"
                  class="form-control"
                  id="id_upc"
                  placeholder="UPC"
                  v-model="internalProduct.upc"
                />
              </div>
              <div class="form-group col-md-3">
                <label for="id_brand">MPN</label>
                <input
                  type="text"
                  class="form-control"
                  id="id_mpn"
                  placeholder="MPN"
                  v-model="internalProduct.mpn"
                />
              </div>
            </div>
          </fieldset>

          <fieldset class="form-group p-3 border">
            <legend class="w-auto px-2">
              <i class="fa fa-th-large" aria-hidden="true"></i> Size
            </legend>
            <div class="form-row">
              <div id="common-fields" class="form-inline col-md-12"></div>
            </div>
          </fieldset>

          <fieldset class="form-group p-3 border">
            <legend class="w-auto px-2">
              <i class="fa fa-list-ul" aria-hidden="true"></i> Features
            </legend>
            <div class="form-row">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="id_bullet_point1">Feature 1</label>
                  <input
                    type="text"
                    class="form-control"
                    id="id_bullet_point1"
                    placeholder="Bullet Point 1"
                    v-model="internalProduct.bullet_point1"
                  />
                </div>
                <div class="form-group">
                  <label for="id_bullet_point2">Feature 2</label>
                  <input
                    type="text"
                    class="form-control"
                    id="id_bullet_point2"
                    placeholder="Bullet Point 2"
                    v-model="internalProduct.bullet_point2"
                  />
                </div>
                <div class="form-group">
                  <label for="id_bullet_point3">Feature 3</label>
                  <input
                    type="text"
                    class="form-control"
                    id="id_bullet_point3"
                    placeholder="Bullet Point 3"
                    v-model="internalProduct.bullet_point3"
                  />
                </div>
                <div class="form-group">
                  <label for="id_bullet_point4">Feature 4</label>
                  <input
                    type="text"
                    class="form-control"
                    id="id_bullet_point4"
                    placeholder="Bullet Point 4"
                    v-model="internalProduct.bullet_point4"
                  />
                </div>
                <div class="form-group">
                  <label for="id_bullet_point5">Feature 5</label>
                  <input
                    type="text"
                    class="form-control"
                    id="id_bullet_point5"
                    placeholder="Bullet Point 5"
                    v-model="internalProduct.bullet_point5"
                  />
                </div>
                <div class="form-group">
                  <label for="id_bullet_point6_group">Feature 6</label>
                  <div class="input-group" id="id_bullet_point6_group">
                    <input
                      type="text"
                      class="form-control"
                      id="id_bullet_point6"
                      placeholder="Bullet Point 6"
                      v-model="internalProduct.bullet_point6"
                    />
                    <span class="input-group-btn">
                      <button
                        type="button"
                        id="id_bullet_point6_button"
                        class="btn btn-secondary btn-sm btn-block"
                        v-on:click="prefillBulletPoint6"
                      >
                        Generate
                      </button>
                    </span>
                  </div>
                </div>
                <div class="form-group">
                  <label for="id_bullet_point7_group">Feature 7</label>
                  <div class="input-group" id="id_bullet_point7_group">
                    <input
                      type="text"
                      class="form-control"
                      id="id_bullet_point7"
                      placeholder="Bullet Point 7"
                      v-model="internalProduct.bullet_point7"
                    />
                    <span class="input-group-btn">
                      <button
                        type="button"
                        id="id_bullet_point7_button"
                        class="btn btn-secondary btn-sm btn-block"
                        v-on:click="prefillBulletPoint7"
                      >
                        Generate
                      </button>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </fieldset>

          <!--Domains specific-->

          <fieldset class="form-group p-3 border">
            <legend class="w-auto px-2">
              <i class="fa fa-search" aria-hidden="true"></i> Domain Specific &
              SEO
            </legend>
            <div class="form-row">
              <div class="tabset">
                <template v-for="(domain, index) in domains">
                  <input
                    v-bind:key="domain.id + '_seo'"
                    type="radio"
                    name="seo_tabset"
                    v-bind:checked="index == 0"
                    v-bind:id="'seo_' + domain.id"
                    v-bind:aria-controls="domain.id + '_seo'"
                  />
                  <label
                    v-bind:key="domain.id + '_seo_label'"
                    v-bind:for="'seo_' + domain.id"
                    >{{ domain.name }}</label
                  >
                </template>

                <input
                  type="radio"
                  name="seo_tabset"
                  id="seo_2"
                  aria-controls="2_seo"
                />
                <label key="newitemwholesale_seo_label" for="seo_2"
                  >newitemwholesale</label
                >

                <div class="tab-panels">
                  <section
                    v-for="(dseo, index) in internalProduct.seo"
                    :key="'seo_' + dseo.domains_id"
                    v-bind:id="dseo.domains_id + '_seo'"
                    class="tab-panel"
                  >
                    <div class="form-row">
                      <div class="form-group col-md-12">
                        <div class="form-check">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            value=""
                            v-bind:id="'id_' + dseo.domains_id + '_is_active'"
                            v-model="internalProduct.seo[index].is_active"
                          />
                          <label
                            class="form-check-label"
                            v-bind:for="'id_' + dseo.domains_id + '_is_active'"
                          >
                            Active product for domain
                          </label>
                        </div>
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="form-group col-md-12">
                        <label v-bind:for="'id_' + dseo.domains_id + '_title'"
                          >Domain Title</label
                        >
                        <input
                          type="text"
                          class="form-control"
                          v-bind:id="'id_' + dseo.domains_id + '_seo_title'"
                          placeholder="Title"
                          v-model="internalProduct.seo[index].title"
                        />
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="form-group col-md-12">
                        <label
                          v-bind:for="'id_' + dseo.domains_id + '_seo_title'"
                          >SEO Title</label
                        >
                        <input
                          type="text"
                          class="form-control"
                          v-bind:id="'id_' + dseo.domains_id + '_seo_title'"
                          placeholder="SEO Title"
                          v-model="internalProduct.seo[index].seo_title"
                        />
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="form-group col-md-12">
                        <label
                          v-bind:for="'id_' + dseo.domains_id + '_seo_keywords'"
                          >SEO Keywords</label
                        >
                        <input
                          type="text"
                          class="form-control"
                          v-bind:id="'id_' + dseo.domains_id + '_seo_keywords'"
                          placeholder="SEO Keywords"
                          v-model="internalProduct.seo[index].seo_keywords"
                        />
                      </div>
                      <div class="form-group col-md-12">
                        <label
                          v-bind:for="
                            'id_' + dseo.domains_id + '_seo_description'
                          "
                          >SEO Description</label
                        >
                        <input
                          type="text"
                          class="form-control"
                          v-bind:id="
                            'id_' + dseo.domains_id + '_seo_description'
                          "
                          placeholder="SEO Description"
                          v-model="internalProduct.seo[index].seo_description"
                        />
                      </div>
                      <div class="form-group col-md-12">
                        <label
                          v-bind:for="'id_' + dseo.domains_id + '_seo_handle'"
                          >SEO Handle</label
                        >
                        <input
                          type="text"
                          class="form-control"
                          v-bind:id="'id_' + dseo.domains_id + '_seo_handle'"
                          placeholder="Handle"
                          v-model="internalProduct.seo[index].seo_handle"
                        />
                      </div>
                    </div>
                  </section>
                  <section id="2_seo" class="tab-panel">
                    <div class="form-row">
                      <div class="form-group col-md-12">
                        <div class="form-check">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            value=""
                            id="is_shopify"
                            v-model="internalProduct.is_shopify"
                          />
                          <label
                            class="form-check-label"
                            for="internalProduct.is_shopify"
                          >
                            Up sync this product with Shopify
                          </label>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
              </div>
            </div>
          </fieldset>

          <!--Bundles-->

          <fieldset
            class="form-group p-3 border"
            v-if="internalProduct.is_bundle"
          >
            <legend class="w-auto px-2">
              <i class="fa fa-cubes" aria-hidden="true"></i> Bundle
            </legend>
            <div class="form-row">
              <div v-for="key in ps" :key="key" class="form-check ml-2 mr-4">
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-bind:id="`p${key}ps`"
                  v-bind:value="`is_${key}ps`"
                  v-model="bundlesChkArr"
                  @onclick="clickBundleCheckbox(key)"
                />
                <label class="form-check-label" v-bind:for="`p${key}ps`"
                  >{{ key }}PS</label
                >
              </div>
            </div>
            <div class="form-row">
              <template v-for="(item, index) in bundlesChk">
                <div
                  v-bind:key="index"
                  class="form-group col-md-6"
                  v-if="bundlesChkArr.indexOf(index) >= 0"
                >
                  <div class="card">
                    <div class="card-header">
                      <strong
                        ><i class="fa fa-cubes" aria-hidden="true"></i>
                        {{ item.ps }}PS</strong
                      >
                    </div>
                    <div class="card-body">
                      <div class="form-row">
                        <div class="form-group col-md-9">
                          <label v-bind:for="'id_' + item.ps + 'ps_sku'"
                            >SKU</label
                          >
                          <input
                            type="text"
                            class="form-control"
                            v-bind:id="'id_' + item.ps + 'ps_sku'"
                            placeholder="SKU"
                            v-bind:value="`${bundlesChk[index].ps}PS-${internalProduct.sku}`"
                          />
                        </div>
                        <div class="form-group col-md-3">
                          <label v-bind:for="'id_' + item.ps + 'ps_price'"
                            >Price</label
                          >
                          <ValidationProvider rules="money" v-slot="{ errors }">
                            <div class="input-group mb-2 mr-sm-2">
                              <div class="input-group-prepend">
                                <div class="input-group-text">$</div>
                              </div>
                              <input
                                type="text"
                                class="form-control"
                                v-bind:id="'id_' + item.ps + 'ps_price'"
                                v-model="bundlesChk[index].price"
                                placeholder="Price"
                              />
                            </div>
                            <span class="text-danger"
                              ><small>{{ errors[0] }}</small></span
                            >
                          </ValidationProvider>
                        </div>
                      </div>

                      <div class="form-row">
                        <div class="form-group col-md-4">
                          <label v-bind:for="'id_' + item.ps + 'ps_asin'"
                            >ASIN</label
                          >
                          <input
                            type="text"
                            class="form-control"
                            v-bind:id="'id_' + item.ps + 'ps_asin'"
                            v-model="bundlesChk[index].asin"
                            placeholder="ASIN"
                          />
                        </div>
                        <div class="form-group col-md-4">
                          <label v-bind:for="'id_' + item.ps + 'ps_upc'"
                            >UPC</label
                          >
                          <input
                            type="text"
                            class="form-control"
                            v-bind:id="'id_' + item.ps + 'ps_upc'"
                            v-model="bundlesChk[index].upc"
                            placeholder="UPC"
                          />
                        </div>
                        <div class="form-group col-md-4">
                          <label v-bind:for="'id_' + item.ps + 'ps_mpn'"
                            >MPN</label
                          >
                          <input
                            type="text"
                            class="form-control"
                            v-bind:id="'id_' + item.ps + 'ps_mpn'"
                            v-model="bundlesChk[index].mpn"
                            placeholder="MPN"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </fieldset>

          <!--Combo-->

          <fieldset
            class="form-group p-3 border"
            v-if="internalProduct.is_combo"
          >
            <legend class="w-auto px-2">
              <i class="fa fa-plus-square" aria-hidden="true"></i> Combo
            </legend>
            <div class="form-row">
              <div class="form-group col-md-4">
                <label for="combo_sku_1">SKU</label>
              </div>
              <div class="form-group col-md-1">
                <label for="combo_qty_1">Qty</label>
              </div>
              <div class="form-group col-md-1 text-center small">
                <a href="javascript:" v-on:click="addComboItem"
                  ><i class="fa fa-plus" aria-hidden="true"></i
                ></a>
              </div>
            </div>

            <template v-for="(item, index) in internalProduct.combo">
              <div v-bind:key="index" class="form-row">
                <div class="form-group col-md-4">
                  <input
                    type="text"
                    class="form-control"
                    v-bind:id="'combo_sku_' + index"
                    v-model="internalProduct.combo[index].sku"
                    placeholder="SKU"
                  />
                </div>
                <div class="form-group col-md-1">
                  <select
                    class="form-control"
                    v-model="internalProduct.combo[index].qty"
                  >
                    <option v-for="(i, key) in 10" v-bind:key="key + 1">
                      {{ key + 1 }}
                    </option>
                  </select>
                </div>
                <div class="form-group col-md-1 text-center small">
                  <a
                    href="javascript:"
                    v-bind:key="index"
                    v-on:click="removeComboItem(index)"
                    ><i class="fa fa-minus" aria-hidden="true"></i
                  ></a>
                </div>
              </div>
            </template>
          </fieldset>

          <!--Custom-->

          <div class="form-row">
            <CustomFields
              :readonly="!['', null].includes(internalProduct.internal_product_series_id)"
              :category="internalProduct.internal_product_category_id === '' ? null : internalProduct.internal_product_category_id"
              :internal-product="internalProduct.id"
              :series="
                internalProduct.internal_product_series_id === '' ? null : internalProduct.internal_product_series_id"
              @select="handleCustomFieldsSelect"
            />
          </div>
        </div>
        <!-- close col-md-12 -->
      </div>
      <!-- close row -->
      <div class="row">
        <div class="col-md-12 text-right">
          <button class="btn btn-primary btn-icon-splitfloat-right">
            {{ type }}
          </button>
        </div>
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
import CustomFields from "@/components/Common/CustomFields.vue";
import InternalProductApiRequest from "@/components/ApiRequester/InternalProduct.js";

import CategoryApiRequest from "@/components/ApiRequester/Category.js";
import TypeApiRequest from "@/components/ApiRequester/CategoryTypes.js";
import SeriesApiRequest from "@/components/ApiRequester/CategoryTypesSeries.js";
import BrandApiRequest from "@/components/ApiRequester/Brand.js";
import DomainApiRequest from "@/components/ApiRequester/Domain.js";
import PurposesApiRequest from "@/components/ApiRequester/Purposes.js";

import SkuUniqueApiRequest from "@/components/ApiRequester/SkuUnique.js";
import ReplaceOemsApiRequest from "@/components/ApiRequester/ReplaceOems.js";
import FitModelsApiRequest from "@/components/ApiRequester/FitModels.js";

import CommonFieldApiRequest from "@/components/ApiRequester/CommonField.js";
import { extend, ValidationProvider, ValidationObserver } from "vee-validate";
import { required, double } from "vee-validate/dist/rules";

import "vue-multiselect/dist/vue-multiselect.min.css";
import "vue-multiselect-bootstrap-theme/dist/vue-multiselect-bootstrap4.scss";
import VueMultiselect from 'vue-multiselect';

export default {
  name: "InternalProductForm",
  props: {
    type: {
      required: true,
      type: String,
      validator: (val) => ["Create", "Update"].includes(val),
    },
    item: {
      required: false,
      type: Object,
      default: () => null,
    },
  },
  components: {
    CustomFields,
    ValidationObserver,
    ValidationProvider,
    VueMultiselect,
  },
  data: () => ({
    ps: [1, 2, 4, 10],
    bundlesChkArr: [],
    bundlesChk: {},
    categories: [],
    series: [],
    purposes: [],
    types: [],
    brands: [],
    defaultSelectText: "",
    seo: [],
    newitemwholesale_seo: [],
    combo: [],
    domains: [], //[{'id':1,'label':'Maxtop','slug':'maxtop'},{'id':2,'label':'Bommeow','slug':'bommeow'}],
    domain: [],
    commonFields: [],
    fitModels: [],
    replaceOems: [],
    skuUnique: true,
    internalProduct: {
      id: null,
      sku: "",
      sorting_order: 3,
      retail_price: "",
      //brand: '',
      condition: "",
      title: "",
      internal_product_category_id: "",
      internal_product_series_id: "",
      internal_product_type_id: "",
      internal_product_brand_id: "",
      short_description: "",
      description: "",
      asin: "",
      upc: "",
      mpn: "",
      bullet_point1: "",
      bullet_point2: "",
      bullet_point3: "",
      bullet_point4: "",
      bullet_point5: "",
      wholesale_price: "",
      recommend_product: "",
      seo: [],
      //seo_title: '',
      //seo_description: '',
      //seo_keywords: '',
      //seo_handle: '',
      bullet_point6: "",
      bullet_point7: "",
      is_combo: "",
      combo: "",
      is_bundle: "",
      bundle: "",
      show_code: "",
      is_featured: "",
      min_price: "",
      max_price: "",
      cost: "",
      is_shopify: "",
      purposes_load: true,
      purposes: [],
      purposes_selected: [],
    },
    customFields: {},
  }),

  created() {
    if (this.$props.item !== null) {
      this.internalProduct = Object.assign(this.internalProduct, {
        id: this.$props.item.id,
        sku: this.$props.item.sku,
        sorting_order: this.$props.item.sorting_order,
        retail_price: this.$props.item.retail_price,
        //brand: this.$props.item.brand,
        condition: this.$props.item.condition,
        title: this.$props.item.title,
        internal_product_category_id:
          this.$props.item.internal_product_category_id,
        internal_product_series_id: this.$props.item.internal_product_series_id,
        internal_product_type_id: this.$props.item.internal_product_type_id,
        internal_product_brand_id: this.$props.item.internal_product_brand_id,
        short_description: this.$props.item.short_description,
        description: this.$props.item.description,
        asin: this.$props.item.asin,
        upc: this.$props.item.upc,
        mpn: this.$props.item.mpn,
        bullet_point1: this.$props.item.bullet_point1,
        bullet_point2: this.$props.item.bullet_point2,
        bullet_point3: this.$props.item.bullet_point3,
        bullet_point4: this.$props.item.bullet_point4,
        bullet_point5: this.$props.item.bullet_point5,
        wholesale_price: this.$props.item.wholesale_price,
        recommend_product: this.$props.item.recommend_product,
        seo: this.$props.item.seo,
        //seo_title: this.$props.item.seo_title,
        //seo_description: this.$props.item.seo_description,
        //seo_keywords: this.$props.item.seo_keywords,
        //seo_handle: this.$props.item.seo_handle,
        bullet_point6: this.$props.item.bullet_point6,
        bullet_point7: this.$props.item.bullet_point7,
        combo: this.$props.item.combo,
        bundle: this.$props.item.bundle,
        //weight: this.$props.item.weight,
        is_bundle: this.$props.item.is_bundle,
        is_combo: this.$props.item.is_combo,
        is_featured: this.$props.item.is_featured,
        show_code: this.$props.item.show_code,
        min_price: this.$props.item.min_price,
        max_price: this.$props.item.max_price,
        cost: this.$props.item.cost,
        is_shopify: this.$props.item.is_shopify,
        purposes: this.$props.item.purposes_plug,
        purposes_selected: this.$props.item.purposes_selected,
      });

      //Replace id`s from API to Text-value
      let purposes_selected = this.internalProduct.purposes_selected;
      let newSelected = [];
      let newPurposes = [];
      Object.entries(this.internalProduct.purposes).forEach((entry) => {
        const [key, value] = entry;
        if (purposes_selected.includes(value)) {
          newSelected.push({ text: key, value: value });
        }
        newPurposes.push({ text: key, value: value });
      });
      this.purposes = newPurposes;
      this.internalProduct.purposes_selected = newSelected;

      this.ps.forEach((item) => {
        let key = "is_" + item + "ps";
        let createNew = true;
        for (var index in this.internalProduct.bundle) {
          if (this.internalProduct.bundle[index].ps === item) {
            this.bundlesChk[key] = this.internalProduct.bundle[index];
            this.bundlesChkArr.push(key);
            createNew = false;
          }
        }
        if (createNew) {
          this.addBundleItem(item, null);
        }
      });
    }

    extend("required", required);

    extend("double", {
      ...double,
      message: "Wrong decimal format!",
    });

    extend("money", {
      validate: (value) => {
        if (value === null || value === undefined || value === "") {
          return {
            valid: false,
          };
        }
        //let regex = /^[\\+\\-]{0,1}[0-9]{1,6}[\\.\\,]{0,1}[0-9]{0,2}$/;
        let regex1 = /^[0-9]{1,6}[\\.]{1}[0-9]{0,2}$/;
        let regex2 = /^[0-9]{1,6}$/;
        return {
          valid: regex1.test(value) || regex2.test(value),
        };
      },
      message: "Wrong money format!",
    });

    extend("required", {
      validate(value) {
        return {
          required: true,
          valid: ["", null, undefined].indexOf(value) === -1,
        };
      },
      computesRequired: true,
      message: "This field is required",
    });

    extend("skuunique", {
      validate: this.isSkuUnique,
      message: "This SKU is already exists",
    });
  },

  mounted() {
    document.getElementById("loader").classList.add("active");
    if (this.internalProduct.internal_product_category_id !== "") {
      Promise.all([
        this.fetchCategories(),
        this.fetchSeries(),
        this.fetchTypes(),
        this.fetchBrands(),
        this.fetchDomains(),
        this.fetchCommonFields(),
      ])
        .then(
          ([
            categoryResources,
            seriesResources,
            typeResources,
            brandResources,
            domainsResources,
            commonFieldResources,
          ]) => {
            this.categories = categoryResources;
            this.series = seriesResources;
            this.types = typeResources;
            this.brands = brandResources;
            this.domains = domainsResources;

            this.domains.forEach((item) => {
              let createNew = true;
              for (var index in this.internalProduct.seo) {
                if (this.internalProduct.seo[index].domains_id === item.id) {
                  createNew = false;
                }
              }
              if (createNew) {
                this.internalProduct.seo.push({
                  internal_products_id: this.internalProduct.id,
                  domains_id: item.id,
                  is_active: 1,
                  title: this.internalProduct.title,
                  seo_title: "",
                  seo_description: "",
                  seo_keywords: "",
                  seo_handle: "",
                });
              }
            });

            this.commonFields = commonFieldResources;

            this.renderCommonFields();

            document.getElementById("loader").classList.remove("active");
          }
        )
        .catch(() => {
          document.getElementById("loader").classList.remove("active");
        });
    } else {
      Promise.all([
        this.fetchCategories(),
        this.fetchSeries(),
        this.fetchTypes(),
        this.fetchBrands(),
        this.fetchDomains(),
        this.fetchCommonFields(),
        this.fetchPurposes(),
      ])
        .then(
          ([
            categoryResources,
            seriesResources,
            typeResources,
            brandResources,
            domainsResources,
            commonFieldResources,
            purposesResources,
          ]) => {
            this.categories = categoryResources;
            this.series = seriesResources;
            this.types = typeResources;
            this.brands = brandResources;
            this.domains = domainsResources;
            this.purposes = purposesResources;

            //Replace id`s from API to Text-value
            let newPurposes = [];
            Object.entries(this.purposes).forEach((entry) => {
              const [key, value] = entry;
              newPurposes.push({ text: key, value: value });
            });
            this.purposes = newPurposes;

            this.domains.forEach((item) => {
              let createNew = true;
              for (var index in this.internalProduct.seo) {
                if (this.internalProduct.seo[index].domains_id === item.id) {
                  createNew = false;
                }
              }
              if (createNew) {
                this.internalProduct.seo.push({
                  internal_products_id: this.internalProduct.id,
                  domains_id: item.id,
                  is_active: 1,
                  title: this.internalProduct.title,
                  seo_title: "",
                  seo_description: "",
                  seo_keywords: "",
                  seo_handle: "",
                });
              }
            });

            this.commonFields = commonFieldResources;

            this.renderCommonFields();

            document.getElementById("loader").classList.remove("active");
          }
        )
        .catch(() => {
          document.getElementById("loader").classList.remove("active");
        });
    }
  },
  methods: {
    //Combo items functions

    addComboItem: function () {
      this.internalProduct.combo.push({
        internal_product_id: this.internalProduct.id,
        internal_product_sku_id: "",
        sku: "",
        qty: 1,
      });
    },

    removeComboItem: function (key) {
      this.$delete(this.internalProduct.combo, key);
    },

    //Bundle items functions

    addBundleItem: function (key, el) {
      this.bundlesChk["is_" + key + "ps"] =
        el === null
          ? {
              internal_products_id: this.internalProduct.id,
              ps: key,
              price: "",
              sku: "",
              asin: "",
              upc: "",
              mpn: "",
            }
          : el;
    },

    clickBundleCheckbox: function (key) {
      if (this.bundlesChk.hasOwnProperty("is_" + key + "ps")) {
        delete this.bundlesChk["is_" + key + "ps"];
      } else {
        if (this.internalProduct.bundle.find((el) => el.ps === key)) {
          for (var index in this.internalProduct.bundle) {
            if (this.internalProduct.bundle[index].ps == key) {
              this.addBundleItem(key, this.internalProduct.bundle[index]);
            }
          }
        } else {
          this.addBundleItem(key, null);
        }
      }
    },

    fetchCommonFields() {
      let payload = {};

      if (this.$props.item !== null) {
        payload = Object.assign(
          {},
          {
            internal_product_id: this.internalProduct.id,
          }
        );
      }

      const ApiRequester = new CommonFieldApiRequest();
      return ApiRequester.all(payload).then((response) => response.data);
    },
    renderCommonFields() {
      const parent = document.querySelector("#common-fields");
      this.commonFields.forEach((commonField) => {
        const formGroup = document.createElement("div");
        formGroup.classList.add("form-group");
        formGroup.classList.add("mb-4");
        formGroup.classList.add("w-100");

        const label = document.createElement("label");
        label.classList.add("pr-4");
        label.innerHTML = commonField.label;

        formGroup.append(label);

        if (commonField.type === "multiple-input") {
          commonField.properties.forEach((property) => {
            const el = document.createElement(property.type);
            el.value = property.value;

            el.addEventListener("change", (event) => {
              property.value = event.target.value;
            });

            switch (property.type) {
              case "input": {
                el.type = "number";
                el.setAttribute("min", 0);

                el.classList.add("form-control");
                el.classList.add("form-control-sm");

                const inputGroup = document.createElement("div");
                inputGroup.classList.add("input-group");
                inputGroup.classList.add("input-group-sm");
                inputGroup.classList.add("px-0");
                inputGroup.style.cssText = "width: 100px !important;";
                inputGroup.append(el);

                const inputGroupPrepend = document.createElement("div");
                inputGroupPrepend.classList.add("input-group-prepend");

                const inputGroupText = document.createElement("span");
                inputGroupText.classList.add("input-group-text");
                inputGroupText.innerHTML = property.label;

                inputGroupPrepend.append(inputGroupText);
                inputGroup.append(inputGroupPrepend);
                formGroup.append(inputGroup);

                break;
              }
              case "label": {
                el.innerHTML = property.value;
                el.classList.add("mx-2");
                formGroup.append(el);
                break;
              }
            }
          });
        }
        parent.append(formGroup);
      });
    },
    handleCustomFieldsSelect(customFields) {
      this.customFields = Object.assign({}, customFields);
    },

    handleFormSubmit() {
      const ApiRequester = new InternalProductApiRequest();

      this.ps.forEach((item) => {
        let del = true;
        let key = "is_" + item + "ps";
        this.bundlesChkArr.forEach((value) => {
          if (key === value) {
            del = false;
          }
        });
        if (del) {
          delete this.bundlesChk[key];
        }
      });

      this.internalProduct = Object.assign(this.internalProduct, {
        common_fields: this.commonFields,
        custom_fields: this.customFields,
        bundle: this.bundlesChk,
      });  

      let payload = { data: this.internalProduct };

      switch (this.$props.type) {
        case "Create":
          payload = Object.assign(payload, { method: "POST" });
          break;
        case "Update":
          payload = Object.assign(payload, { method: "PUT" });
          break;
      }

      document.getElementById("loader").classList.add("active");

      ApiRequester.store(payload)
        .then(() => {
          document.getElementById("loader").classList.remove("active");
          this.$emit("submit");
        })
        .catch(() => {
          document.getElementById("loader").classList.remove("active");
        });
    },

    async fetchCategories() {
      const ApiRequester = new CategoryApiRequest();
      return ApiRequester.all().then((response) => response.data.categories);
    },

    async fetchTypes() {
      const ApiRequester = new TypeApiRequest();
      return ApiRequester.types({
        category_id: this.internalProduct.internal_product_category_id,
      }).then((response) => response.data.types);
    },

    async fetchSeries() {
      const ApiRequester = new SeriesApiRequest();
      return ApiRequester.series({
        category_id: this.internalProduct.internal_product_category_id,
        type_id: this.internalProduct.internal_product_type_id,
      }).then((response) => response.data.series);
    },

    async fetchBrands() {
      const ApiRequester = new BrandApiRequest();
      return ApiRequester.all().then((response) => response.data.brands);
    },

    async fetchDomains() {
      const ApiRequester = new DomainApiRequest();
      return ApiRequester.all().then((response) => response.data.data);
    },

    async fetchPurposes() {
      const ApiRequester = new PurposesApiRequest();
      return ApiRequester.all().then((response) => response.data.purposes);
    },

    chooseCategory() {
      document.getElementById("loader").classList.add("active");
      this.fetchTypes()
        .then((typesResources) => {
          this.types = typesResources;
          document.getElementById("loader").classList.remove("active");
        })
        .catch(() => {
          document.getElementById("loader").classList.remove("active");
        });
      this.fetchSeries()
        .then((seriesResources) => {
          this.series = seriesResources;
          document.getElementById("loader").classList.remove("active");
        })
        .catch(() => {
          document.getElementById("loader").classList.remove("active");
        });
    },

    chooseType() {
      document.getElementById("loader").classList.add("active");
      this.fetchSeries()
        .then((seriesResources) => {
          this.series = seriesResources;
          document.getElementById("loader").classList.remove("active");
        })
        .catch(() => {
          document.getElementById("loader").classList.remove("active");
        });
    },

    prefillSeoTitle() {
      this.$set(
        this.internalProduct,
        "seo_title",
        [this.internalProduct.title, this.internalProduct.sku].join(" ")
      );
    },

    prefillBulletPoint6() {
      document.getElementById("loader").classList.add("active");
      const ApiRequester = new FitModelsApiRequest();
      ApiRequester.all({ sku: this.internalProduct.sku })
        .then((response) => {
          this.fitModels = response.data.fitModels;
          document.getElementById("loader").classList.remove("active");
          ApiRequester.finishCall();
          this.$set(
            this.internalProduct,
            "bullet_point6",
            Object.keys(this.fitModels).length === 0
              ? ""
              : this.fitModels.join(" ")
          );
        })
        .catch(() => {
          document.getElementById("loader").classList.remove("active");
        });
    },

    prefillBulletPoint7() {
      document.getElementById("loader").classList.add("active");
      const ApiRequester = new ReplaceOemsApiRequest();
      ApiRequester.all({ sku: this.internalProduct.sku })
        .then((response) => {
          this.replaceOems = response.data.replaceOems;
          document.getElementById("loader").classList.remove("active");
          ApiRequester.finishCall();
          this.$set(
            this.internalProduct,
            "bullet_point7",
            Object.keys(this.replaceOems).length === 0
              ? ""
              : this.replaceOems.join(" ")
          );
        })
        .catch(() => {
          document.getElementById("loader").classList.remove("active");
        });
    },

    isSkuUnique() {
      const ApiRequester = new SkuUniqueApiRequest();
      return ApiRequester.all({
        id: this.internalProduct.id,
        sku: this.internalProduct.sku,
      })
        .then((response) => {
          this.skuUnique = response.data.skuUnique;
          ApiRequester.finishCall();
          return this.skuUnique;
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.error {
  border-color: red;
}
</style>
